/**
 * User role values - must stay in sync with App\Enums\UserRoleEnum.
 */
export const ROLES = Object.freeze({
    RIDER: 'rider',
    CAR_ENTHUSIAST: 'car_enthusiast',
    PHOTOGRAPHER: 'photographer',
    ADMIN: 'admin',
})

/**
 * Localized role labels for UI (badges, dropdowns, role switcher pills).
 */
export const ROLE_LABELS = Object.freeze({
    [ROLES.RIDER]: 'Motorkář',
    [ROLES.CAR_ENTHUSIAST]: 'Autičkář',
    [ROLES.PHOTOGRAPHER]: 'Fotograf',
    [ROLES.ADMIN]: 'Admin',
})

/**
 * Material Symbols icons per role.
 */
export const ROLE_ICONS = Object.freeze({
    [ROLES.RIDER]: 'two_wheeler',
    [ROLES.CAR_ENTHUSIAST]: 'directions_car',
    [ROLES.PHOTOGRAPHER]: 'photo_camera',
    [ROLES.ADMIN]: 'shield_person',
})

/**
 * Which zone each role lives in. Mirrors `UserRoleEnum::zone()` -
 * adding a new role here MUST also add a case in the PHP enum.
 */
export const ROLE_TO_ZONE = Object.freeze({
    [ROLES.RIDER]: 'profile',
    [ROLES.CAR_ENTHUSIAST]: 'profile',
    [ROLES.PHOTOGRAPHER]: 'studio',
    [ROLES.ADMIN]: 'admin',
})
